import { FormFieldGroup, FormLabel, FormTextarea } from '$components'
import { Input } from './index'

export function EditMedicalNotesContent() {
  return (
    <div className="flex flex-col gap-stack-section flex-grow">
      <FormFieldGroup>
        <FormLabel htmlFor={Input.Allergies}>
          Allergies
        </FormLabel>

        <FormTextarea
          name={Input.Allergies}
          placeholder="Enter allergies..."
          rows={3}
        />
      </FormFieldGroup>

      <FormFieldGroup>
        <FormLabel htmlFor={Input.MedicalNotes}>
          Additional Notes
        </FormLabel>

        <FormTextarea
          name={Input.MedicalNotes}
          placeholder="Enter additional notes..."
          rows={3}
        />
      </FormFieldGroup>
    </div>
  )
}
